/* eslint-disable */
import axios from "axios";
import config from "@assets/config.json"; // api 请求json
// 通用 Module
const state = {
    joinData: null,
};
const mutations = {
    setJoinData(state, data) {
        state.joinData = data;
    },
};
const getters = {
    getJoinData: state => {
        return state.joinData;
    },
};
const actions = {
    getJoinById({
        rootState
    }, id) {
        // 根据公司Id获取展会信息
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/join?id=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    delByCompany({
        rootState
    }, id) {
        // 根据公司Id删除展会信息
        return new Promise((resolve, reject) => {
            axios
                .delete(`${config.api.reqApi}/api/join?id=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getByCompany({
        rootState
    }, opt) {
        // 根据公司Id获取展会信息
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/join/GetByCompany`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getIndustryListAndChildren({
        rootState
    }) {
        // （获取类型下的所有展商行业数据
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/Industry/GetListAndChildren`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getIndustryListById({
        rootState
    }, id = "00000000-0000-0000-0000-000000000000") {
        // 根据父id获取行业
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/Industry/GetByParentId?parentId=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve([]);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getExhibitionAll({
        rootState
    }, opt) {
        // 根据父id获取行业
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/exhibition/GetAll`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getHallByExhibition({
        rootState
    }, id) {
        // 根据展会Id获取展馆
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/exhall/GetByExhibition?exhibitionId=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getCategoryByExhibition({
        rootState
    }, id) {
        // 根据展会Id获取产品类别
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/category/GetByExhibition?exhibitionId=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getCategoryByExhibitionList({
        rootState
    }, id) {
        // 根据展会Id获取产品类别
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/category/GetAndListByExhibition?exhibitionId=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },

    joinExhibition({
        rootState
    }, opt) {
        // 加入展会
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/join`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    putJoinExhibitionInfo({
        rootState
    }, opt) {
        // 修改加入展会的信息
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/join`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getExhibitionById({
        rootState
    }, id) {
        // 根据展会id
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/exhibition?id=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getJoinExhibitionInfoByCompId({
        rootState
    }, opt = {
        compId: "",
        exhibitionId: ""
    }) {
        // 通过公司和展会id获取参展信息
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/join/GetByCompId?compId=${opt.compId}&exhibitionId=${opt.exhibitionId}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    setDefaultJoinExhibition({
        rootState
    }, opt) {
        // 设置公司默认参展信息
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/join/SetDefault`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getCatalogueByJoinId({
        rootState
    }, id) {
        // 获取会刊信息
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/catalogue/?joinId=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getCatalogueCeShi({
        rootState
    }) {
        //测试
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/catalogueDown/?id=2a00214d-7f55-45aa-9458-74a1ff174f7a`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getCatalogueType({
        rootState
    }) {
        // 获取会刊企业类别
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/catalogueType/GetList`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    submitCatalogue({
        rootState
    }, opt) {
        // 提交会刊（新增）
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/catalogue`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    submitCatalogueDown({
        rootState
    }, opt) {
        // 提交会刊（修改）
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/catalogue`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    editCatalogueDown({
        rootState
    }, opt) {
        // 修改未审核的会刊修改信息
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/CatalogueDown`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getCatalogueDown({
        rootState
    }, id) {
        // 获取会刊修改记录
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/catalogueDown/GetRecord?joinId=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getFasciaBoard({
        rootState
    }, id) {
        // 获取楣板信息
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/lintel/?joinId=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getFasciaBoardDown({
        rootState
    }, id) {
        // 获取楣板修改记录
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/lintelDown/GetRecord?joinId=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    submitFasciaBoard({
        rootState
    }, opt) {
        // 提交楣板（新增）
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/lintel`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    submitFasciaBoardDown({
        rootState
    }, opt) {
        // 提交楣板（修改）
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/lintel`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    editFasciaBoardDown({
        rootState
    }, opt) {
        // 修改未审核的楣板修改信息
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/LintelDown`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getInvoice({
        rootState
    }, id) {
        // 获取发票信息
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/invoice/GetByCompId?compId=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getInvoiceDown({
        rootState
    }, id) {
        // 获取发票修改记录
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/invoiceDown/GetRecord?joinId=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    submitInvoice({
        rootState
    }, opt) {
        // 提交发票（新增）
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/invoice`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    submitInvoiceDown({
        rootState
    }, opt) {
        // 提交发票（修改）
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/invoice`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    editInvoiceDown({
        rootState
    }, opt) {
        // 修改未审核的发票修改信息
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/InvoiceDown`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },

    getRegionList({
        rootState
    }) {
        // 获取区域
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/Region/GetListAndChildren`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getCountryList({
        rootState
    }) {
        // 获取国家列表
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/country/GetList`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getCityByParentId({
        rootState
    }, id) {
        // 获取省份列表
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/city/GetByParentId?parentId=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },

    getCityList({
        rootState
    }) {
        // 获取中国省市信息
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/city/GetListAndChildren`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getProChannels({
        rootState
    }) {
        // 获取产品渠道
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/ProChannels/GetList`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getProOffices({
        rootState
    }) {
        // 获取产品应用科室
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/ProSectionOffices/GetList`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getWeAppCode({
        rootState
    }, opt) {
        // 获取微信小程序码
        // targetType: 目标类型：0公司，1产品，2商机
        // targetId: 目标Id
        // scene: 小程序页面所需场景值
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/WeAppSmallCode?targetType=${opt.targetType}&targetId=${opt.targetId}&scene=${opt.scene}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getEmail({
        rootState
    }, opt) {
        // 获取邮箱账号

        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/ApplyEmailAccount/GetEmailAccount`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    editEmail({
        rootState
    }, opt) {
        // 获取邮箱账号

        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/ApplyEmailAccount`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getFile({
        rootState
    }, key) {
        //

        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/file?key=${key}`, {
                    responseType: "arraybuffer",
                    ...rootState.header
                })
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    downFile({
        rootState
    }, opt) {
        //

        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/WeAppSmallCode/GetFile?targetType=${opt.targetType}&targetId=${opt.targetId}&scene=${opt.scene}`, {
                    responseType: "arraybuffer",
                    ...rootState.header
                })
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                        const aLink = document.createElement("a");
                        let blob = new Blob([data.data], {
                            type: "image/jpeg"
                        });
                        console.log(blob, "blob");
                        aLink.href = URL.createObjectURL(blob);
                        aLink.setAttribute("download", "小程序二维码" + ".jpg"); // 设置下载文件名称
                        aLink.click();
                        //document.body.appendChild(aLink)
                        this.$refs.loadElement.appendChild(aLink);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },

    /**展商证申请接口 */
    qrcode({
        rootState
    }, opt) {
        // 获取二维码
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/DeExCardPlanConfig/GetByJoinId`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    GetAuthentication({
        rootState
    }, opt) {
        //  查询已认证数量
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/DeExCardPlan/GetAuthenticationCountByJoinId`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    GetList({
        rootState
    }, opt) {
        //  查询证件申请列表
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/DeExCardPlan/GetListByJoinId`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getFormDate({
        rootState
    }, opt) {
        //  通过展商申请链接的参数获取默认信息
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/DeExCardPlan/GetFormDataByUrl`, opt, rootState.formHeaders.headers)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    PostDeExCardPlan({
        rootState
    }, opt) {
        //  单个添加参展名单
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/DeExCardPlan`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    DeletePlan({
        rootState
    }, opt) {
        //  单个添加参展名单
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/DeExCardPlan/DeletePlan`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getCountryList({
        rootState
    }) {
        //  单个添加参展名单
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/Country/GetList`, {}, rootState.formHeaders.headers)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    //获取邮箱验证码
    getEmailVerCode({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/VerCode/email/Send`, opt, rootState.formHeaders.headers)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getMsgCode({
        rootState
    }, opt) {
        // 获取短信验证码
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/VerCode/sms/send`, opt, rootState.formHeaders.headers)
                .then(data => {
                    if (data.data) {
                        // if (data.data.successed) {
                        //   this.$Message.success('验证码已发送');
                        // } else {
                        //   this.$Message.fail('验证码发送失败');
                        // }
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    validateEmailCode({}, opt) {
        // 效验邮箱验证码
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/VerCode/email/Validate`, opt)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    validateMsgCode({}, opt) {
        // 效验短信验证码
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/VerCode/sms/validate`, opt)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    //查重
    CheckRepeat({
        rootState
    }, opt) {
        //  单个添加参展名单
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/DeExCardDown/CheckRepeat`, opt, rootState.formHeaders.headers)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    //下载PDF
    DownPdf({
        rootState
    }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/Pdf/GetDeExCardDownEn?Id=${id}`, rootState.formHeaders.headers)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    //获取导入结果
    getDeExCardDownImportNew({
        rootState
    }, opt) {
        //  单个添加参展名单
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/DeExCardDown/ImportNew`, opt, rootState.formHeaders.headers)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    getExhibitionByIdNew({
        rootState
    }, id) {
        // 根据展会id
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/exhibition?id=${id}`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },

    //   采买咨询
    //  采买咨询列表
    getExhibitionBuyConsult({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/CallingCard/wechatCompPage`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    //导出 采买咨询
    getExhibitionBuyExport({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/CallingCard/ExcelExport`, opt, {
                    responseType: "arraybuffer",
                    ...rootState.header
                })
                .then(data => {
                    if (data.data) {
                        const aLink = document.createElement("a");
                        let blob = new Blob([data.data], {
                            type: "application/vnd.ms-excel"
                        });
                        aLink.href = URL.createObjectURL(blob);
                        if (opt.conditions.state == 0) {
                            aLink.setAttribute("download", "采买咨询-待接收" + ".xlsx"); // 设置下载文件名称
                        }
                        if (opt.conditions.state == 1) {
                            aLink.setAttribute("download", "采买咨询-已接收" + ".xlsx"); // 设置下载文件名称
                        }

                        // aLink.setAttribute("download", "采买供需" + ".xlsx"); // 设置下载文件名称
                        aLink.click();
                        //document.body.appendChild(aLink)
                        this.$refs.loadElement.appendChild(aLink);

                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },

    // 展商后台   修改状态
    putExhibitionUpdateState({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${config.api.reqApi}/api/CallingCard/updateCallingState`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err.response.data);
                });
        });
    },

    //   采买咨询  获取联系人
    getContactsList({
        rootState
    }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/CallingCard/GetDeExHiConList?compId=${id}`, {}, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },
    // 添加联系人
    getExhibitionAddUser({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${config.api.reqApi}/api/CallingCard/DeExHiConAdd`, opt, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },


    // 删除已接收
    delReceived({
        rootState
    }, id) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`${config.api.reqApi}/api/CallingCard?id=${id}&isSms=false`, rootState.header)
                .then(data => {
                    if (data.data) {
                        resolve(data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },


    // https://zwyd-api.pharmchina.com.cn/api/ApplyCompany/PCOrNHNEExist?exhibitionId=展会id&companyName=公司名称&unifiedCode=统一社会信用代码
    getPCOrNHNEExist ({
        rootState
    }, opt) {
        // 获取省份列表
        return new Promise((resolve, reject) => {
            axios
                .get(`${config.api.reqApi}/api/ApplyCompany/PCOrNHNEExist?exhibitionId=${opt.exhibitionId}&companyName=${opt.companyName}&unifiedCode=${opt.unifiedCode}`, rootState.header)
                .then(data => {
                        resolve(data.data);
                })
                .catch(err => {
                    console.log(err);
                });
        });
    },





};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};